export enum AnalyticsV2Keys {
  LastUpdated = 'LastUpdated',
  // Data by App Usage
  UsageSummary = 'UsageSummary',
  UsageByTimePeriod = 'UsageByTimePeriod',
  UsageByRetentionIntensity = 'UsageByRetentionIntensity',
  UsageByRegion = 'UsageByRegion',
  UsageMomGrowth = 'UsageMomGrowth',
  // Data by endpoints
  UsageByHost = 'UsageByHost',
  UsageByOS = 'UsageByOS',
  UsageByPlatform = 'UsageByPlatform',
  // Data by capability
  UsageByCapability = 'UsageByCapability',
}

export enum AnalyticsV1Keys {
  ActiveUsers = 'ActiveUsers',
  Metrics = 'Metrics',
}
